module.exports = __webpack_public_path__ + "components/assets/moka-white-09c9405396fae4cf5f465de6c1b8ecbd.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/assets/moka-white.svg
// module id = 207
// module chunks = 0 1